import customHeaders, { getSpace } from '../../common/headers';
import { LineChart } from '../../charts/LineChart/LineChart';
import { OlegHttps, OlegHttp } from '../../fetchUrls';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { ModalTableActions } from '../../components/Modal/ModalTableActions/ModalTableActions';
import {
  DropDownSelector,
  SliderRange,
  DropContainer,
  Tabs,
  TableBox,
  Checkbox,
  CheckboxToggleBlue,
  ButtonBasic
} from '@lk-gtcom/ecomlab-components';
import './AnalyticsPageComponent.scss';
import { useChartData, useDataTable } from '../../common/hooks';
import { WrapperLineChart } from '../../charts/WrapperCharts/WrapperLineChart/WrapperLineChart';
import { CardMetricV1 } from '../../components/CardsComponents/CardMetricV1/CardMetricV1';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import useGeneralStore from '../../store/general';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { StepItem } from '../../components/StepItem/StepItem';
import { usePushNotifications } from '../../common/pushNotification';
import { TableInfo } from '../../components/TableInfo/TableInfo';
import MetricCards from '../../components/CardsComponents/MetricCards/MetricCards';
import { msToLocalDate, periodWeek } from '../../common/constant';
import { FilterArticles } from '../../components/FilterArticles/FilterArticles';
import { useResponseHandler } from '../../common/auth';
import { Tooltip } from '../../components/TooltipV2/Tooltip';

const options_period_date = [
  { label: 'По часам', value: 'hour' },
  { label: 'По дням', value: 'day' },
  { label: 'По неделям', value: 'week' },
  { label: 'По месяцам', value: 'month' },
];

const options_period = [
  { label: 'По дням', value: 'day' },
  { label: 'По неделям', value: 'week' },
  { label: 'По месяцам', value: 'month' },
];

// Название метрик для страницы low-hight
const listMetricsLowHigh = [
  'conversion_high_views_high',
  'conversion_high_views_low',
  'conversion_low_views_high',
  'conversion_low_views_low',
  'without_sales'
]

const AnalyticsPageComponent = ({
  tabs,
  relativeUrl,
  filters,
  rangeBox,
  date,
  selectedMp,
  selectedApi,
  selectedBrand,
  selectedCategory,
  selectedCampaign,
  selectedWarehouse,
  selectedSuperStauts,
  selectedAdvCampaignType,
  selectedAdvStatus,
  activeSubItems,
  route,
  setSelectedCategory,
  setSelectedBrand,
  selectedAdvCampaign,
  isTableRequest,
  setIsTableRequest,
  selectedFboFbm,
  selectedSummary,
  selectedMargin,
  selectedBrandLens,
  updateURL,
  // Чекбоксы
  check,
  setCheck,
  isNegativeMarg,
  setIsNegativeMarg,
  isBadIdc,
  setIsBadIdc,
  isInAction,
  setIsInAction,
  isWithSebestoimost,
  setIsWithSebestoimost,
  isDeliveryDate,
  setIsDeliveryDate,
  isDiffRub,
  setIsDiffRub,
  isWithRemnants,
  setIsWithRemnants,
  isInAdvertising,
  setIsInAdvertising,
  isReverse, setIsReverse,
  isStock, setIsStock,
  isReady,
  selectedPeriod,
  setSelectedPeriod
}) => {
  // Рефы
  const fileInputRef = useRef(null);
  const location = useLocation();

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const [showDropBox, setShowDropBox] = useState(false);

  let [date_from, date_to] = date;
  const [pageValue, setPageValue] = useState();

  // const [chartData, setChartData] = useState([]);
  const [setChartData, chartData, setChartFuncs] = useChartData();
  const { resetChart } = setChartFuncs;

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } =
    setTableFuncs;
  const { total, loading } = tableProps;
  const [loadingUpload, setLoadingUpload] = useState(false)


  const [chartLoading, setChartLoading] = useState(false);

  const params = useParams();
  const activeTab = params['*'];

  const [metrics, setMetrics] = useState([]);
  const [selectedMetrics, setSelectedMetrics] = useState([]);

  const [checkedProducts, setCheckedProducts] = useState([]);
  const [checkedId, setCheckedId] = useState([]);

  const [checkFbs, setCheckFbs] = useState(false)


  const [selectedMetric, setSelectedMetric] = useState([]);
  const [tableMetrics, setTableMetrics] = useState([]);
  const [arrayTableMetrics, setArrayTableMetrics] = useState([]);

  // Карточки
  const [metricCardList, setMetricCardList] = useState([])

  // Фильтры
  const [filterValue, setFilterValue] = useState([]);
  const [isModalFilter, setIsModalFilter] = useState(false);


  // Загрузить шаблон
  const onUploadFileToPromotion = (file) => {
    if (!file) {
      return;
    }

    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')

    const url = `https://apps1.ecomru.ru:4448/api/v2/promotion/rule/file/validate`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        // Пытаемся распарсить ответ от сервера как JSON
        const data = await res.json();

        if (!res.ok) {
          const errorMessage = data.detail || res.statusText;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`);
          throw new Error(`Upload failed: ${res.status} ${errorMessage}`);
        }
        return data;
      })
      .then((data) => {
        addSuccessPush('Файл успешно загружен')
        if (fileInputRef.current) fileInputRef.current.value = ''
        setFilterValue(data?.product_ids)
        setTimeout(() => setIsTableRequest(!isTableRequest), 100)
        // setInitialFilterValue(data?.product_ids)
        // setTimeout(() => fetchTableDataPrice(), 1000)
      })
      .catch((err) => {
        handleRequestError(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setLoadingUpload(false)
      });
  };

  const handleFileChangeLink = async (e) => {
    onUploadFileToPromotion(e.target.files[0])
  };

  const metricUnits = {
    'руб.': '₽',
    'шт.': 'шт',
    '%': '%',
  };
  function transformDataMetrics(data, colors) {
    return data.map((item, index) => {
      const foundUnit = Object.keys(metricUnits).find((unit) =>
        item.label.includes(unit)
      );
      const unit = foundUnit ? metricUnits[foundUnit] : '';
      const label = foundUnit
        ? item.label.replace(`, ${foundUnit}`, '')
        : item.label;
      const value = parseFloat(item.value.replace(/\s/g, ''));
      const color = colors[index % colors.length];
      return {
        label: `${label}:`,
        value: value,
        unit: unit,
        color: color,
      };
    });
  }

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setFilters([])
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Метрики в график
  const fetchMetricsList = (signal) => {

    setMetrics([]);
    setSelectedMetric([])

    if (
      route == 'advertising' ||
      route == 'returns_cancellations' ||
      route == 'analytics'
    ) {
      const curr_path = route == 'analytics' ? 'general' : route;
      const reason_params = route == 'returns_cancellations'
        ?
        (pageValue == 'reason' ? '?reason=true' : '?reason=false')
        : '';

      let url = `${OlegHttps}/api/v1/analytics/${curr_path}/graph/metrics${reason_params}`

      if (route == 'marginality_analysis') {
        url = `https://apps1.ecomru.ru:4450/api/v1/cost/graph/metrics`
      }

      fetch(url, {
        method: 'GET',
        headers: headers,
        signal
      })
        .then(handleTableResponse)
        .then((data) => {
          setMetrics(data);
        })
        .catch(handleRequestError)
        .finally(() => {
          setChartLoading(false);
          if (signal?.signal?.aborted) {
            return;
          }
        });
    }
  };

  // Метрики в шапку таблицы
  const fetchMetricsForTable = (params, signal) => {

    setTableMetrics([]);

    let url = `${OlegHttps}/api/v1/analytics/${relativeUrl}/summary_data`

    if (relativeUrl === 'returns_cancellations') {
      url = `${OlegHttps}/api/v1/analytics/${relativeUrl}/summary/data`;
    }

    let filtersParam;

    if (params) {
      [filtersParam] = params;
    }

    let api_id_list;
    let brand_id_list;
    let category_id_list;
    let campaign_id_list;
    let warehouse_id_list;
    let brand_name_list

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    } else {
      api_id_list = ['all'];
    }
    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }
    if (selectedBrandLens?.length > 0) {
      brand_name_list = selectedBrandLens?.map((el) => el.value);
    }
    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }
    if (selectedCampaign?.length > 0) {
      campaign_id_list = selectedCampaign?.map((el) => el.value);
    } else {
      campaign_id_list = ['all'];
    }
    if (selectedWarehouse?.length > 0) {
      warehouse_id_list = selectedWarehouse?.map((el) => el.value);
    }

    let [date_from, date_to] = date;
    date_from = msToLocalDate(date_from);
    date_to = msToLocalDate(date_to);

    const body = JSON.stringify({
      // filters: filtersParam,
      page: 1,
      limit: 10,
      date_from,
      date_to,
      warehouse_id_list,
      campaign_id_list,
      offer_id_list: ['all'],
      category_id_list,
      brand_id_list,
      brand_name_list,
      api_id_list,
      period: pageValue === 'date' ? selectedPeriod?.value : '',
      reverse: false,
    });

    fetch(url, {
      body,
      method: 'POST',
      headers: headers,
      signal,
    })
      .then(handleTableResponse)
      .then((data) => {
        if (data?.length && data[0]?.label) {
          setTableMetrics(data);
        }
      })
      .catch(handleRequestError);
  };

  // График
  const fetchChartData = (signal) => {
    if (selectedApi?.length < 1) return;
    if (!selectedMetric || (selectedMetric?.length === 0)) return
    if (!selectedMetric) return;

    setChartLoading(true);
    const is_delivery = (route == 'marginality_analysis' || route == 'analytics' || route == 'advertising') ? `?delivery_date=${isDeliveryDate ? 'creation_date' : 'delivery_date'}` : ''

    let url = `${OlegHttps}/api/v1/analytics/${relativeUrl}/graph/${pageValue}${is_delivery}`

    if (route == 'marginality_analysis') url = `https://apps1.ecomru.ru:4450/api/v1/cost/graph/${pageValue}`



    let api_id_list;
    let brand_id_list;
    let category_id_list;
    let campaign_id_list;
    let warehouse_id_list;
    let adv_campaign_id_list;
    let mp_id_list;
    let super_status_list;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    }
    if (selectedMp?.length > 0) {
      mp_id_list = selectedMp?.map((el) => el.value);
    }
    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }
    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }
    if (selectedCampaign?.length > 0) {
      campaign_id_list = selectedCampaign?.map((el) => el.value);
    } else {
      campaign_id_list = ['All'];
    }
    if (selectedWarehouse?.length > 0) {
      warehouse_id_list = selectedWarehouse?.map((el) => el.value);
    }
    if (selectedAdvCampaign?.length > 0) {
      adv_campaign_id_list = selectedAdvCampaign?.map((el) => el.value);
    } else {
      adv_campaign_id_list = ['all'];
    }

    if (selectedSuperStauts?.length > 0) {
      super_status_list = selectedSuperStauts?.map((el) => el.value);
    } else {
      super_status_list = ['all'];
    }

    let [date_from, date_to] = date;
    date_from = msToLocalDate(date_from);
    date_to = msToLocalDate(date_to);
    const margin_filter = route == 'marginality_analysis' ? { margin_filter: selectedMargin?.value } : {}

    const body = JSON.stringify({
      category_id_list,
      brand_id_list,
      api_id_list,
      date_from,
      date_to,
      campaign_id_list,
      warehouse_id_list,
      mp_id_list,
      initial: false,
      metrics: Array.isArray(selectedMetric) ? selectedMetric : (selectedMetric ? [selectedMetric] : []),
      period: pageValue === 'date' ? selectedPeriod?.value : '',
      graph_filter: checkedId?.length > 0 ? checkedId : ['all'],
      offer_id_list: ['all'],
      adv_campaign_id_list,
      super_status_list,
      ...margin_filter
    });

    fetch(url, {
      body,
      method: 'POST',
      headers,
      signal,
    })
      .then(handleTableResponse)
      .then((json) => {
        setChartData(json);
        setChartLoading(false);
      })
      .catch((err) => {
        handleRequestError(err)
        setChartLoading(false);
      })
      .finally(() => {
        if (signal?.signal?.aborted) {
          return;
        }
      });
  };

  // Карточки low-hight
  const fetchMetricCard = (string) => {

    let url = `https://apps1.ecomru.ru:4450/api/v1/low_high/summary/block/${string}`;

    let api_id_list;
    let brand_id_list;
    let category_id_list;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    } else {
      api_id_list = ['all'];
    }
    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }
    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    let [date_from, date_to] = date;
    date_from = msToLocalDate(date_from);
    date_to = msToLocalDate(date_to);

    const body = JSON.stringify({
      date_from,
      date_to,
      category_id_list,
      brand_id_list,
      api_id_list,
    });

    fetch(url, {
      body, method: 'POST', headers: headers,
      // signal
    })
      .then(handleTableResponse)
      .then((data) => {
        if (data) {
          setMetricCardList((prev) => [...prev, data]);
        }
      })
      .catch(handleRequestError);
  };

  const [metricsTable, setMetricsTable] = useState([])
  const [selectedMetricsTable, setSelectedMetricsTable] = useState([])
  const [isLoadingMetricsTable, setIsLoadingMetricsTable] = useState(false)

  // Метрики для таблицы price
  const fetchMetricCardTable = () => {
    setIsLoadingMetricsTable(true)
    let url = `https://apps1.ecomru.ru:4450/api/v2/analytics/${route}/pivot/metrics/${pageValue}`;

    fetch(url, { method: 'GET', headers: headers })
      .then(handleTableResponse)
      .then((data) => {
        if (data && Array.isArray(data)) {
          setMetricsTable(data);
          setSelectedMetricsTable(data?.[0] ? [data?.[0].value] : [])
        }
      })
      .catch(handleRequestError)
      .finally(() => setIsLoadingMetricsTable(false));
  };

  useEffect(() => {
    if ((pageValue === 'price_by_days') || (pageValue === 'stock_by_dynamics_days')) {
      fetchMetricCardTable()
    } else {
      setSelectedMetrics([])
    }
  }, [pageValue]);

  // Таблица
  const fetchTableData = (params, signal) => {
    if (!isReady) return
    if (((pageValue === 'price_by_days') || (pageValue === 'stock_by_dynamics_days')) && !selectedMetricsTable?.length) {
      return
    }
    setCheckedProducts([]);

    if (!selectedApi.length) return;
    if (!pageValue) return;

    setLoading(true);
    const [sort, filtersParam] = params || [];
    const baseUrl = window.location.hostname.match('localhost') ? OlegHttp : OlegHttps;
    const externalPath = pageValue === 'date' ? `/${selectedPeriod?.value}` : '';
    const withoutZeroStock = pageValue === 'turnover' ? `?without_zero_stock=${check}` : '';
    const margin_filter = route == 'marginality_analysis' ? { margin_filter: selectedMargin?.value } : {}

    const isPivot = (pageValue === 'stock_by_dynamics_days') ? 'pivot/' : ''
    const path_abc = (pageValue === 'IDC_by_products') ? 'idc/table' : 'idc/matrix'

    const urlMap = {
      'ABCXYZ': `${baseUrl}/api/v1/analytics/stock/table/${pageValue}`,
      'orders': `${baseUrl}/api/v2/analytics/orders/table/${pageValue}`,
      'general': `${baseUrl}/api/v1/analytics/general/table/${pageValue}?delivery_date=${isDeliveryDate ? 'creation_date' : 'delivery_date'}`,
      'stock': `${baseUrl}/api/v2/analytics/stock/${isPivot}table/${pageValue}`,
      'advertising': `${baseUrl}/api/v1/analytics/advertising/table/${pageValue}?delivery_date=${isDeliveryDate ? 'creation_date' : 'delivery_date'}`,
      'prices': `${baseUrl}/api/${((pageValue === 'price_by_products') || (pageValue === 'price_by_days')) ? 'v2' : 'v1'}/analytics/prices${(pageValue === 'price_by_days') ? '/pivot' : ''}/table/${pageValue}`,
      'marginality_analysis': `${baseUrl}/api/v1/cost/table/${pageValue}`,
      'returns_cancellations': `${baseUrl}/api/v1/analytics/returns_cancellations/${pageValue}`,
      'classification': `${baseUrl}/api/v2/${((pageValue === 'IDC_by_products') || (pageValue === 'IDC_by_groups')) ? path_abc : 'abc/table'}/${pageValue}?group_name=${isDiffRub ? 'stock_rub_diff' : 'stock_diff'}`,
      'low-high': `${baseUrl}/api/v2/low_high/table/${pageValue}`,
      'brand_report': `${baseUrl}/api/v1/lense/table/general`,
      // ?fbo_fbs=${checkFbs ? 'fbs' : 'fbo'}
      'slices': `${baseUrl}/api/v1/lense/slice/table/general?order_param=Name&order_param_direction=DESC&have_stock=${isWithRemnants ? 'ON' : 'OFF'}&in_ad=${isInAdvertising ? 'ON' : 'OFF'}`
    };

    let url = urlMap[relativeUrl] || '';
    if (sort?.length) url += `${(route == 'slices' || route == 'analytics' || route == 'advertising' || route == 'ABCXYZ') ? '&' : '?'}order_param=${sort[0]}&order_param_direction=${sort[1]}`;

    const mapValues = (selectedList, defaultValue = ['all']) => selectedList?.length ? selectedList.map(el => el.value) : defaultValue;
    const stock_params = ((route === 'stock') && (pageValue === 'product')) ?
      {
        stock_filter: mapValues(selectedFboFbm)
      } : {}

    const with_sebestoimost = (
      (relativeUrl === 'prices') ||
      (relativeUrl === 'stock') ||
      (relativeUrl === 'marginality_analysis') ||
      (relativeUrl === 'classification')
    ) ?
      { with_sebestoimost: isWithSebestoimost } : {}

    const negative_marg = (pageValue === 'price_by_products') ?
      { negative_marg: isNegativeMarg } : {}

    const bad_idc = (
      (pageValue === 'price_by_products') ||
      (relativeUrl === 'stock') ||
      (relativeUrl === 'classification')
    ) ?
      { bad_idc: isBadIdc } : {}
    const in_action = ((relativeUrl === 'stock') || (relativeUrl === 'prices')) ?
      { in_action: isInAction } : {}

    const with_stock = (
      (relativeUrl === 'stock') ||
      (relativeUrl === 'prices') ||
      (relativeUrl === 'classification')
    ) ? { with_stock: isStock } : {}

    const metrics = ((pageValue === 'price_by_days') || (relativeUrl === 'stock')) ? { metrics: selectedMetricsTable } : {}

    const body = JSON.stringify({
      filters: filtersParam,
      mp_id_list: mapValues(selectedMp),
      category_id_list: mapValues(selectedCategory),
      brand_id_list: mapValues(selectedBrand),
      brand_name_list: mapValues(selectedBrandLens),
      api_id_list: mapValues(selectedApi),
      campaign_id_list: mapValues(selectedCampaign),
      offer_id_list: filterValue,
      warehouse_id_list: mapValues(selectedWarehouse),
      date_from: msToLocalDate(date[0]),
      date_to: msToLocalDate(date[1]),
      page: paginatorRef.current.page,
      limit: isReverse ? 90 : paginatorRef.current.limit,
      period: ((pageValue == 'date') || (route == 'marginality_analysis') || (pageValue === 'price_by_products')) ? selectedPeriod?.value : '',
      reverse: pageValue === 'date' ? isReverse : false,
      // group_missed_sales: relativeUrl === 'advertising' ? selectedGroupMissedSales?.value || 'all' : undefined,
      adv_campaign_id_list: mapValues(selectedAdvCampaign),
      super_status_list: (route === 'orders-and-sales' || route === 'marginality_analysis') ? mapValues(selectedSuperStauts) : undefined,
      adv_campaign_type_list: route === 'advertising' ? mapValues(selectedAdvCampaignType) : undefined,
      adv_status_list: route === 'advertising' ? mapValues(selectedAdvStatus) : undefined,
      group_list: route === 'low-high' ? mapValues(selectedSummary) : undefined,
      ...margin_filter,
      ...stock_params,
      ...with_sebestoimost,
      ...negative_marg,
      ...bad_idc,
      ...in_action,
      ...with_stock,
      ...metrics
    });

    fetch(url, { body, method: 'POST', headers, signal })
      .then(handleTableResponse)
      .then(json => {
        setTable(json);
        setLoading(false)
      })
      .catch(handleRequestError)
      .finally(() => {
        if (signal?.signal?.aborted) {
          setLoading(false)
          return;
        }
      });
  };

  const fetchAllData = (signal) => {
    fetchTableData([], signal);
  };

  const body_obj = () => {
    if (!selectedMargin?.value) return

    const body = JSON.stringify({
      // super_status_list: [],
      // brand_id_list: getValueMultiFilter(selectedBrand),
      // category_id_list: getValueMultiFilter(selectedCategory),
      api_id_list: getValueMultiFilter(selectedApi),
      date_from: msToLocalDate(date[0]),
      date_to: msToLocalDate(date[1]),
      margin_filter: selectedMargin?.value || '',
      with_sebestoimost: isWithSebestoimost
      // period: selectedPeriod?.value
    });
    if (selectedApi?.length > 0) {
      return body
    } else {
      return null
    }
  }


  useEffect(() => {
    const colors = ['red', 'blue'];
    const transformedData = transformDataMetrics(tableMetrics, colors);
    setArrayTableMetrics(transformedData);
  }, [tableMetrics]);

  // useEffect(() => {
  //   const abortController = new AbortController();
  //   const { signal } = abortController;

  //   fetchMetricsForTable(null, signal);

  //   return () => {
  //     if (!iniitalQuery) {
  //       abortController.abort();
  //     }
  //   };
  // }, [
  //   pageValue,
  //   selectedPeriod,
  //   isTableRequest,
  //   date,
  // ]);

  useEffect(() => {
    setMetricCardList([])
    if (route == 'low-high') {
      listMetricsLowHigh.forEach((item) => {
        fetchMetricCard(item)
      })
    }
  }, [route, isTableRequest, date]);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    fetchMetricsList(signal);

    return () => {
      abortController.abort();
    };
  }, [route]);

  useEffect(() => {
    if (route == 'returns_cancellations') {
      setSelectedMetric([])
      fetchMetricsList();
    }
  }, [pageValue]);

  useEffect(() => {
    setPageValue(activeTab);
    setIsReverse(false);
    // resetTable();
  }, [activeTab]);

  useEffect(() => {
    if (!isModalFilter && isReady) {
      const abortController = new AbortController();
      const { signal } = abortController;
      resetTable();
      fetchAllData(signal);
      resetChart();
      return () => {
        abortController.abort();
      };
    }
  }, [
    pageValue,
    date,
    check,
    isReverse,
    isStock,
    isWithSebestoimost,
    isBadIdc,
    isInAction,
    isNegativeMarg,
    isDeliveryDate,
    isWithRemnants,
    isInAdvertising,
    isModalFilter,
    isDiffRub,
    isTableRequest,
    route,
    filterValue,
    selectedMetricsTable,
    checkFbs
  ]);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    if (
      route == 'analytics' ||
      route == 'advertising' ||
      route == 'returns_cancellations' ||
      route == 'marginality_analysis'
    ) {
      if (selectedMetric) {
        fetchChartData(signal);
      }
    }
    return () => abortController.abort();
  }, [
    selectedMetric,
    checkedId,
    selectedPeriod,
    isTableRequest,
    isDeliveryDate,
    date
  ]);

  useEffect(() => {
    setIsTableRequest(!isTableRequest)
  }, [selectedBrand, selectedCategory]);

  useEffect(() => {
    let list_id;
    if (pageValue == 'brand') {
      list_id = checkedProducts.map(({ brand_id }) => brand_id);
    }
    if (pageValue == 'category') {
      list_id = checkedProducts.map(({ category_id }) => category_id);
    }
    if (pageValue == 'product') {
      list_id = checkedProducts.map(({ offer_id }) => offer_id);
    }
    if (route == 'marginality_analysis') {
      if (pageValue == 'product') {
        list_id = checkedProducts.map((el) => {
          return el?.['Товар']?.[4]
        });
      }
      if (pageValue == 'category') {
        list_id = checkedProducts.map((el) => {
          return el?.['Категория']?.[0]
        });
      }
      if (pageValue == 'brand') {
        list_id = checkedProducts.map((el) => {
          return el?.['Бренд']?.[0]
        });
      }
    }
    if (list_id) {
      setCheckedId(list_id);
    }
  }, [checkedProducts]);

  const [isResetChecxbox, setIsResetCheckbox] = useState(false);

  // Модалка для таблицы
  const [isModalTable, setIsModalTable] = useState(false);
  const btn_table = [
    {
      label: 'Сбросить все',
      onClick: (e) => {
        setIsResetCheckbox(!isResetChecxbox);
      },
    },
  ];

  useEffect(() => {
    if (checkedProducts?.length > 0) {
      setIsModalTable(true);
    } else {
      setIsModalTable(false);
    }
  }, [checkedProducts]);

  return (
    <>
      {isModalTable && (
        <ModalTableActions
          products={checkedProducts}
          btns={btn_table}
          setIsModal={(e) => setIsModalTable(e)}
        />
      )}

      <div className="analytics-page">
        <TitlePage
          title={activeSubItems?.label}
        />

        <div className="filter-group">
          {filters(
            route == 'slices'
            &&
            <>
              <Checkbox
                value={isWithRemnants}
                onChange={() => {
                  updateURL({ with_remnants: !isWithRemnants || null });
                  setIsWithRemnants(!isWithRemnants)
                }} >
                С остатками
              </Checkbox>

              <Checkbox
                value={isInAdvertising}
                onChange={() => {
                  updateURL({ in_advertising: !isInAdvertising || null });
                  setIsInAdvertising(!isInAdvertising)
                }} >
                В рекламе
              </Checkbox>
            </>
            // ||
            // route == 'brand_report'
            // &&
            // <>
            //   <Tooltip
            //     text={<p className='text_tooltip'>FBO <span>(продажи со склада площадки)</span> по умолчанию.
            //       <br /><br />
            //       Нажмите на переключатель чтобы увидеть FBS <span>(продажи со склада продавца)</span>
            //     </p>}
            //     maxWidth='110px'
            //     child={
            //       <CheckboxToggleBlue
            //         text='FBS'
            //         value={checkFbs}
            //         onChange={(e) => setCheckFbs(!checkFbs)}
            //       />
            //     }
            //   />
            // </>
          )}
        </div>

        {route != 'slices' &&
          <div className="toolbar-medium">
            <Tabs
              query={location?.search}
              tabs={tabs}
              pageValue={pageValue}
            />

            <div className="range-group-btn-and-range-box">
              {pageValue == 'turnover' &&
                <Checkbox
                  value={check}
                  onChange={() => {
                    updateURL({ check: !check || null });
                    setCheck(!check)
                  }}>
                  Без 0 остатков
                </Checkbox>
              }

              {
                (route == 'analytics' || route == 'advertising') &&
                <>
                  <div className='analytics-page__label'>
                    По дате доставки
                    <CheckboxToggleBlue
                      value={isDeliveryDate}
                      onChange={(e) => {
                        updateURL({ delivery_date: !isDeliveryDate || null });
                        setIsDeliveryDate(!isDeliveryDate)
                      }}
                    />
                    По дате создания
                  </div>
                </>
              }

              {(pageValue == 'date' || route == 'marginality_analysis') &&
                <DropDownSelector
                  options_prop={relativeUrl === 'general' ? options_period_date : options_period}
                  state={selectedPeriod}
                  setState={setSelectedPeriod}
                  isClearable={false}
                  width='100%'
                  maxWidth='150px'
                  onBlur={(e) => {
                    updateURL({ period: selectedPeriod });
                    setIsTableRequest(!isTableRequest);
                  }}
                />
              }

              {(pageValue !== 'price_by_products') && rangeBox}
            </div>
          </div>}

        {route == 'marginality_analysis' && <StepItem
          title={'Кликните по столбцу диаграммы, чтобы использовать в фильтре.'}
        />}

        {route == 'marginality_analysis' && <div className='analytics-page__charts-group'>
          <WrapperLineChart
            url={`https://apps1.ecomru.ru:4450/api/v1/cost/diagram/category_fact_margin_rub`}
            body={body_obj()}
            nameChart="Топ-5 категорий по марже, ₽"
            setSelected={(e) => {
              if (selectedCategory.find(el => el.value == 'all')) {
                setSelectedCategory([])
              }
              setSelectedCategory(e)
            }}
          />

          {/* <WrapperLineChart
            url={`https://apps1.ecomru.ru:4450/api/v1/cost/diagram/category_fact_margin_per`}
            body={body_obj()}
            nameChart="Топ-5 категорий по марже, %"
            setSelected={(e) => {
              if (selectedCategory.find(el => el.value == 'all')) {
                setSelectedCategory([])
              }
              setSelectedCategory(e)
            }}
          /> */}

          <WrapperLineChart
            url={`https://apps1.ecomru.ru:4450/api/v1/cost/diagram/brand_fact_margin_rub`}
            body={body_obj()}
            nameChart="Топ-5 брендов по марже, ₽"
            setSelected={(e) => {
              if (selectedCategory.find(el => el.value == 'all')) {
                setSelectedBrand([])
              }
              setSelectedBrand(e)
            }}
          />

          {/* <WrapperLineChart
            url={`https://apps1.ecomru.ru:4450/api/v1/cost/diagram/brand_fact_margin_per`}
            body={body_obj()}
            nameChart="Топ-5 брендов по марже, %"
            setSelected={(e) => {
              if (selectedCategory.find(el => el.value == 'all')) {
                setSelectedBrand([])
              }
              setSelectedBrand(e)
            }}
          /> */}
        </div>}

        {route == 'marginality_analysis' && <TableInfo
          // title='Test table'
          // data={{
          //   data: [[
          //     ['text',{color: 'red', background: 'rgb(229, 231, 235)'}], 
          //     ['text', {color: 'green'}], 
          //     ['text', {color: 'blue'}], 
          //     ['text', {color: 'grey'}],
          //   ]],
          //   header: [
          //     "Магазин",
          //     "Неотвеченные отзывы",
          //     "Неотвеченные вопросы",
          //     "Отзывы на модерации",
          //   ]
          // }}
          data={{}}
        />}

        {!(
          route === 'orders-and-sales' ||
          route === 'slices' ||
          route === 'brand_report' ||
          pageValue === 'status' ||
          pageValue == 'list' ||
          route == 'ABCXYZ' ||
          route == 'low-high' ||
          route == 'prices' ||
          route == 'stock'
        ) ? (
          <DropContainer
            showDropBox={showDropBox}
            setShowDropBox={(e) => setShowDropBox(e)}
            name={
              chartData?.title
                ? chartData?.title
                : 'Динамика показателей за выбранный период'
            }
          >
            <section
              className="charts-container"
              style={date ? { flexDirection: 'column', gap: '24px' } : {}}
            >
              <div
                className="charts-group"
                style={{ flexDirection: 'column', gap: '24px', width: '100%' }}
              >
                <LineChart
                  {...chartData}
                  multi={route == 'marginality_analysis'}
                  legendPosition="top"
                  loading={chartLoading}
                  legend={metrics}
                  selectedLegend={selectedMetrics}
                  setSelectedLegend={setSelectedMetrics}
                  selectedMetric={selectedMetric}
                  setSelectedMetric={setSelectedMetric}
                  metricsList={metrics}
                />
              </div>
            </section>
          </DropContainer>
        ) : null}

        {pageValue === 'price' && <SliderRange />}

        {route == 'low-high' &&
          <div className='analytics-page__metrics-list'>
            {metricCardList?.length ?
              metricCardList?.map(({ labels, data }, ind) => {
                return <CardMetricV1
                  label={listMetricsLowHigh?.[ind]}
                  key={labels?.title + ind + metricCardList?.length}
                  header={labels?.header}
                  data={data}
                  title={labels?.title}
                />
              }).slice(0, 5)
              :
              [...Array(5)]?.map((el, ind) => {
                return <CardMetricV1
                  key={ind}
                  header={[]}
                  data={[]}
                  title={'-'}
                />
              })
            }
          </div>}

        {((pageValue === 'price_by_days') || (pageValue === 'stock_by_dynamics_days')) && <MetricCards
          loading={isLoadingMetricsTable}
          metrics={metricsTable}
          selectedValues={selectedMetricsTable}
          onSelectionChange={setSelectedMetricsTable}
        />}

        <TableBox
          metrics={
            Array.isArray(arrayTableMetrics) && arrayTableMetrics.length > 0
              ? arrayTableMetrics
              : null
          }
          {...tableProps}
          loading={loading}
          paginator={!isReverse}
          hideSorting={isReverse}
          fetchCallback={(e) => fetchTableData(e)}
          ref={paginatorRef}
          onCheck={(e) => setCheckedProducts(e)}
          onUncheckAllDependence={[pageValue, date, isResetChecxbox]}
          staticTD={
            (
              (pageValue !== 'stock_by_products') &&
              (pageValue !== 'price_by_days') &&
              (pageValue !== 'price_by_products') &&
              (pageValue !== 'LH_by_products') &&
              (pageValue !== 'ABC_by_products') &&
              (pageValue !== 'IDC_by_products')

            )
          }
          child={
            <>
              <FilterArticles
                filterValue={filterValue}
                setFilterValue={setFilterValue}
              />

              <>
                <ButtonBasic
                  blue
                  text='Шаблон загрузки Excel'
                  size='32px'
                  onClick={() => {
                    const link = document.createElement('a');
                    link.href = 'https://file.ecomru.ru:4453/api/v1/file/download/c656bc1a-1482-42a9-a674-9e6b5062ccab';
                    link.download = 'template.xlsx'; // Имя файла
                    link.style.display = 'none'; // Скрываем ссылку
                    document.body.appendChild(link);
                    link.click();
                  }}
                />

                <div className='modal-rules-table__btn-upload'>
                  <ButtonBasic
                    green
                    width='auto'
                    text='Загрузить'
                    size='32px'
                    loading={loadingUpload}
                  />


                  <input
                    type="file"
                    id="fileInput"
                    onChange={handleFileChangeLink}
                    ref={fileInputRef}
                  />
                </div>
              </>

              {(pageValue === 'date' && route != 'slices') && (
                <Checkbox
                  value={isReverse}
                  onChange={(checked) => {
                    updateURL({ reverse: !isReverse || null });
                    setIsReverse(checked)
                  }}
                >
                  Перевернуть
                </Checkbox>
              )}

              {(
                (relativeUrl === 'stock') ||
                (relativeUrl === 'prices') ||
                (relativeUrl === 'classification')
              ) && (
                  <Checkbox
                    value={isStock}
                    onChange={(checked) => {
                      updateURL({ stock: checked || null });
                      setIsStock(checked)
                    }}
                  >
                    С остатком
                  </Checkbox>
                )}

              {((relativeUrl === 'prices') ||
                (relativeUrl === 'stock') ||
                (relativeUrl === 'marginality_analysis') ||
                (relativeUrl === 'classification')) &&
                <Checkbox value={isWithSebestoimost}
                  onChange={() => {
                    updateURL({ with_sebestoimost: !isWithSebestoimost || null });
                    setIsWithSebestoimost(!isWithSebestoimost)
                  }}>
                  С себестоимостью
                </Checkbox>}

              {(pageValue === 'price_by_products') &&
                <Checkbox value={isNegativeMarg}
                  onChange={() => {
                    updateURL({ negative_marg: !isNegativeMarg || null });
                    setIsNegativeMarg(!isNegativeMarg)
                  }}>
                  C отрицательной маржинальностью
                </Checkbox>}

              {((pageValue === 'price_by_products') ||
                (relativeUrl === 'stock') ||
                (relativeUrl === 'classification')
              ) &&
                <Checkbox value={isBadIdc}
                  onChange={() => {
                    updateURL({ bad_idc: !isBadIdc || null });
                    setIsBadIdc(!isBadIdc)
                  }} >
                  C плохой оборачиваемостью
                </Checkbox>}

              {((pageValue === 'price_by_products') || (relativeUrl === 'stock')) &&
                <Checkbox value={isInAction}
                  onChange={() => {
                    updateURL({ in_action: !isInAction || null });
                    setIsInAction(!isInAction)
                  }} >
                  В акциях
                </Checkbox>}

              {(pageValue == 'IDC_by_groups') &&
                <>
                  <div className='analytics-page__label'>
                    в шт
                    <CheckboxToggleBlue
                      value={isDiffRub}
                      onChange={(e) => {
                        updateURL({ diff_rub: !isDiffRub || null });
                        setIsDiffRub(!isDiffRub)
                      }}
                    />
                    в руб
                  </div>
                </>}
            </>
          }
        />
      </div>
    </>
  );
};

export { AnalyticsPageComponent };
